<div fxLayout="row" fxLayoutAlign="end center">
    @if(enableTitle){
        <h2>{{name}}</h2>
    }
    <div style="margin-right: 20px" >
        <div fxLayout="row" fxLayoutAlign="start center">
            @if(enableSearch){
                <mat-form-field class="mat-form-field-override form-margin" style="white-space: nowrap;">
                    <input matInput
                            [(ngModel)]="searchTerm"
                            placeholder="search" />
                    <span matSuffix>
                        <button mat-icon-button style="font-size: 30px; padding: 3px 0px 0px 0px !important; height: inherit !important" (click)="searchExecute()"><app-icon-core [icon]="'search'" [inline]="true"></app-icon-core></button>
                        <button mat-icon-button style="font-size: 30px; padding: 3px 0px 0px 0px !important; height: inherit !important" (click)="searchClear()"><app-icon-core [icon]="'clear-search'" [inline]="true"></app-icon-core></button>
                    </span>
                </mat-form-field>
            }
            <mat-form-field class="mat-form-field-override form-margin page-size-form">
                <mat-label>Page size</mat-label>
                <mat-select [(ngModel)]="pageSizeLocal" (ngModelChange)="updatePageSize()">
                    <mat-option *ngFor="let opt of pageSizeOptions" [value]="opt">
                        {{opt}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-paginator [length]="itemCount"
                        [pageSize]="pageSizeLocal"
                        [hidePageSize]="true"
                        [showFirstLastButtons]="true"
                        (page)="updatePage()"
                        style="display: inline-block"
                        #paginator>        
            </mat-paginator>
            @if(enableSettings){
                <button mat-icon-button [matMenuTriggerFor]="columnMenu" >
                    <app-icon-core [icon]="'settings'" [inline]="false"></app-icon-core>
                </button>
                <mat-menu #columnMenu="matMenu">
                    <button mat-menu-item *ngFor="let c of optionalDisplayColumns">
                        <mat-checkbox [(ngModel)]="c.display"
                                    (change)="setupDisplayColumns()">{{c.title}}</mat-checkbox>
                    </button>
                </mat-menu>
            }
            
            @if(enableBatch){
                <button mat-icon-button 
                        [disabled]="selectedIds.length === 0"
                        [matMenuTriggerFor]="batchEditMenu"
                        style="margin-right: 10px;"
                        title="Batch edit">
                    <app-icon-core [icon]="'edit'" [inline]="false"></app-icon-core>
                </button>
                <mat-menu #batchEditMenu="matMenu">
                    <span *ngIf="mode === 'assets'">
                        <span *ngIf="selectedIds.length === 1">
                            <button mat-menu-item 
                                    (click)="executeBatchCommand('assetName')">
                                <span>Name</span>
                            </button>
                            <button mat-menu-item 
                                    (click)="executeBatchCommand('assetRef')">
                                <span>Ref</span>
                            </button>
                        </span>
                    </span>
                    <span *ngIf="mode === 'accrualPrepayments'">
                        <span *ngIf="selectedIds.length === 1">
                            <button mat-menu-item 
                                    (click)="executeBatchCommand('title')">
                                <span>Title</span>
                            </button>
                        </span>
                    </span>
                    <button mat-menu-item 
                            (click)="executeBatchCommand('class')">
                        <span appCompanyDynFieldHeader fieldName="class">Class</span>
                    </button>
                    <button mat-menu-item 
                            (click)="executeBatchCommand('location')">
                            <span appCompanyDynFieldHeader fieldName="location">Location</span>
                    </button>
                </mat-menu>
            }            
        </div>
    </div>
    
    
</div>